module.exports = __webpack_public_path__ + "img/nft_default_image.c90f9666.png";